import clsx from 'clsx';
import React from 'react';
import { NoOpQueryResultBox } from './NoOpQueryResultBox';
import { QueryResultBox } from './QueryResultBox';

export interface QueryResultBaseProps {
  className?: string;
  queryOutput: any;
  hasMoreResults?: boolean;
  noResultOp?: boolean;
  showingInsideCard?: boolean;
  useVirtualScrolling?: boolean;
}

export interface CollapsibleQueryResultProps extends QueryResultBaseProps {
  isExpandedView?: boolean;
  toggleExpandedView: Function;
}

export function CollapsibleQueryResult({
  className = '',
  noResultOp,
  queryOutput,
  hasMoreResults,
  showingInsideCard,
  useVirtualScrolling,
  isExpandedView,
  toggleExpandedView
}: CollapsibleQueryResultProps) {
  return (<>
    {noResultOp ? (
      <NoOpQueryResultBox className={className} showingInsideCard={showingInsideCard} />
    ) : null}

    {queryOutput ? (
      <QueryResultBox
        className={clsx(
          className,
          showingInsideCard && 'border-0'
        )}
        showingInsideCard={showingInsideCard}
        queryOutput={queryOutput}
        hasMoreResults={hasMoreResults}
        isExpandedView={isExpandedView}
        toggleExpandedView={toggleExpandedView}
        useVirtualScrolling={useVirtualScrolling}
      />
    ) : null}
  </>);
}
